export default __webpack_public_path__ + "static/media/del_icon.9184ec1a.svg";